import { BriefcaseIcon } from '@heroicons/react/24/outline';
import classNames from 'classnames';
import React from 'react';

interface Props {
  className?: string;
}

export const ClientAvatar: React.FC<Props> = ({ className }) => (
  <div className={classNames('bg-shade flex h-12 w-12 items-center justify-center rounded', className)}>
    <BriefcaseIcon className="h-5 w-5" />
  </div>
);
